// Global JS

document.addEventListener('DOMContentLoaded', () => {

    let miniCart = document.getElementById('mini-cart');
    let closeMiniCartBtn = document.getElementById('close-mini-cart');
    let miniCartBtn = document.getElementById('mini-cart-button');
    let body = document.getElementsByTagName('body');

    function openMiniCart() {
        miniCart.classList.add('show')
    }

    function closeMiniCart() {
        miniCart.classList.remove('show')
    }

    // function toggleMiniCart() {
    //     miniCart.classList.toggle('show')
    //     console.log('here')
    // }

    miniCartBtn.addEventListener('click', () => {
        openMiniCart();
    });

    closeMiniCartBtn.addEventListener('click', () => {
        closeMiniCart();
    });

    // if ((body[0].classList.contains("collection") || body[0].classList.contains("product")) && miniCart.querySelector('.item')) {
    //     openMiniCart();
    // }
})

